import {OlivioLuminaire} from './olivioLuminaire';

class OlivioCandelabraLuminaire extends OlivioLuminaire {
	static designName = 'candelabra';

	static poleSizes = {
		35: {
			height: 3.5,
			topMargin: 0,
			topDiameter: 0.06,
			bottomDiameter: 0.12,
			verticalAngle: 0,
			maxHeight: 3.5,
			xBaseOffset: 0,
			ratio: 0
		},
		45: {
			height: 4.5,
			topMargin: 0,
			topDiameter: 0.06,
			bottomDiameter: 0.114,
			verticalAngle: 0,
			maxHeight: 4.5,
			xBaseOffset: 0,
			ratio: 0
		},
	};

	static models = {
		pole: {},
		bracket: {},
	};

	static modelPatterns = [
		{type: 'pole', pattern: /^Candelabra_Pole_(?<id>[0-9]+)$/i, storageKeys: ['id']},
		{type: 'bracket', pattern: /^Candelabra_Top_(?<id>[0-9]+)$/i, storageKeys: ['id']},
	];

	static singleBracket = true;

	static supportLayouts = false;

	static checkCollisions = false;

	static defaultConfig = {
		poleHeight: 4.5,
		candelabraTop: '3.000',
		numberOfHeads: 3,
		layout: 'none',
	};


	static getPoleId(configValues) {
		return String(configValues.poleHeight).replace('.', '');
	}

	static getBracketId(configValues, index) {
		return configValues.candelabraTop.replace('.', '');
	}

	static getHeadAngle(index, bracketId) {
		switch (bracketId) {
			case '1000': return 0;
			case '2120': return index * 120;
			case '2180': return index * 180;
			case '3000': return index * 120;
		}
		return 0;
	}

}

export {OlivioCandelabraLuminaire};

